(function() {
    'use strict';

    angular.module('app').controller('PaypalPaymentController', PaypalPaymentController);

    function PaypalPaymentController($scope, MetadataFactory) {
        $scope.assignToken = assignToken;
        $scope.paypalButton = true;
        var braintreeToken;
        $scope.countries = [];

        MetadataFactory.get({'models[]': [
                'Shipping'
            ]}).$promise.then(loadAfterMetadata);

        function loadAfterMetadata(index) {
            angular.forEach(index.Shipping.countries, function(value, key) {
                $scope.countries[value] = key;
            }, $scope.countries);
            assignToken(braintreeToken);
        }

        function convert(country)
        {
            return $scope.countries[country];
        }

        function assignToken(token){
            braintreeToken = token;
            braintree.setup(braintreeToken, 'custom', {
                onReady: function (integration) {
                    $scope.paypalButton = false;
                    $scope.order.device_data = integration.deviceData;
                    $scope.$digest();
                },
                onPaymentMethodReceived: function (obj) {
                    $scope.order.payment_method_nonce = obj.nonce;
                    $scope.order.paypal_details = obj;
                    $scope.$apply();
                    $scope.$parent.submitPaypal();
                },
                paypal: {
                    singleUse: false,
                    useraction: 'commit',
                    currency: 'USD',
                    locale: 'en_US',
                    enableShippingAddress: true,
                    billingAgreementDescription: 'One time wristband order. Additional options available upon request.',
                    shippingAddressOverride: {
                        recipientName: $scope.order.shipToName,
                        streetAddress: $scope.order.shipping_address.line1,
                        extendedAddress: $scope.order.shipping_address.line2,
                        locality: $scope.order.shipping_address.city,
                        countryCodeAlpha2: convert($scope.order.shipping_address.country),
                        postalCode: $scope.order.shipping_address.postalCode,
                        region: $scope.order.shipping_address.state,
                        phone: $scope.order.shipToPhone,
                        editable: false
                    },
                    headless: true
                },
                dataCollector: {
                    paypal: true
                }
            });
        }
    }
})();